"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editableGridCheckboxCell = "editable-grid-checkbox-cell";
exports.editableGridCheckboxField = "editable-grid-checkbox-field";
exports.editableGridDeleteItem = "editable-grid-delete-item";
exports.disabled = "disabled";
